import { get } from "lodash";

const DEFAULT_CREATION_TITLES = ["nouveau projet", "new project"];

export const resolveAdvisorProjectTitle = (project, fallback) => {
  const name = String(get(project, "name") || "").trim();
  if (name && !DEFAULT_CREATION_TITLES.includes(name.toLowerCase())) {
    return name;
  }
  const fullName = [
    get(project, "contact.user.firstname"),
    get(project, "contact.user.lastname"),
  ]
    .filter(Boolean)
    .join(" ")
    .trim();
  return fullName || fallback;
};
